@if (showLabel()) {
  <label class="form-label" for="productList">
    {{ label() }}
    @if (required()) {
      <span class="text-danger">*</span>
    }
  </label>
}
<div class="d-flex align-items-end">
  <input
    type="text"
    class="form-control rounded-0 rounded-start-3"
    [placeholder]="displayPlaceholder()"
    aria-label="Amount (to the nearest dollar)"
    disabled="true"
    [value]="selectedProductTitle()"
  />
  <button
    class="btn btn-primary btn-h42 rounded-0 rounded-end-3 px-3 py-2"
    [disabled]="disabled()"
    (click)="openProductModelFilter()"
  >
    <i class="bi bi-plus-circle fs-16 lh-1"></i>
  </button>
</div>

<ng-template #producModelFilter let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header p-3 shadow-sm">
      <div class="d-flex flex-column">
        <h2 class="modal-title mb-0">Product Filter</h2>
      </div>
      <span (click)="closeProductModelFilter()" role="button" class="ms-auto">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body p-3">
      <div class="row gy-3 mb-4">
        @if (!productListId()) {
          <div class="col-lg-3 col-md-6">
            <generic-dropdown
              [label]="'Product List'"
              [items]="productList$ | async"
              [placeholder]="'Select Product List'"
              [allowSearch]="true"
              [clearable]="true"
              [required]="true"
              [(ngModel)]="selectedProductListId"
              (ngModelChange)="onProductListChange($event)"
            ></generic-dropdown>
          </div>
        }
        <div class="col-lg-3 col-md-6">
          <generic-dropdown
            [label]="'Categories'"
            [items]="categoryListByProductListId$ | async"
            [placeholder]="'Select Categories'"
            [allowSearch]="true"
            [clearable]="true"
            [(ngModel)]="selectedCategoryId"
            (ngModelChange)="onCategoryChange($event)"
          ></generic-dropdown>
        </div>

        <div class="col-lg-3 col-md-6">
          <generic-dropdown
            [label]="'Subcategory'"
            [items]="subcategories$ | async"
            [placeholder]="'Select Subcategory'"
            [allowSearch]="true"
            [clearable]="true"
            [(ngModel)]="selectedSubcategoryId"
            (ngModelChange)="onSubcategoryChange($event)"
          ></generic-dropdown>
        </div>
        <div class="col-lg-3 col-md-6">
          <input-field [label]="'Search'" [placeholder]="'Search'" [(ngModel)]="search"></input-field>
        </div>
      </div>

      <div class="flex-fill overflow-hidden">
        <div class="table-outer table-theme">
          <div class="table-responsive h-100">
            <p-table [value]="productDisplay()">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="code">Product Code <p-sortIcon field="code"></p-sortIcon></th>
                  <th pSortableColumn="description">Description <p-sortIcon field="description"></p-sortIcon></th>
                  <th pSortableColumn="category">Category <p-sortIcon field="category"></p-sortIcon></th>
                  <th pSortableColumn="subcategory">Sub Category <p-sortIcon field="subcategory"></p-sortIcon></th>
                  <th pSortableColumn="class">Class <p-sortIcon field="class"></p-sortIcon></th>
                  <th pSortableColumn="unit">Unit <p-sortIcon field="unit"></p-sortIcon></th>
                  <!-- <th>Status</th> -->
                  <th pSortableColumn="sellable">Sellable <p-sortIcon field="sellable"></p-sortIcon></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-product>
                <tr (click)="selectProduct(product)">
                  <td class="position-relative">
                    {{ product?.code }}
                  </td>
                  <td>{{ product?.description }}</td>
                  <td>{{ product?.subcategory?.category?.code }}</td>
                  <td>{{ product?.subcategory?.code }}</td>
                  <td>{{ product?.productClass?.name }}</td>
                  <td>{{ product?.oUnitCode?.oUnitCode }}</td>
                  <td>
                    <i
                      class="bi {{
                        product?.sellable ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'
                      }}"
                    ></i>
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr>
                  <td colspan="10" class="text-center">No products found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-shadow btn-h42" (click)="closeProductModelFilter()">Cancel</button>
    </div>
  </div>
</ng-template>
